import { combineReducers } from 'redux';

import proposals from './proposalsReducer';

const rootReducer = combineReducers({
  proposals,
});

export default rootReducer;
